// import React, { useState, useEffect } from "react";
// import { NavLink } from "react-router-dom";
// import TeacherCard from "./TeacherCard";
// import { FiSearch } from "react-icons/fi";
// import { FaPlus } from "react-icons/fa";
// import { getHitID } from "../../../config/HitIDStorage";
// import axios from "axios";
// import apiKey from "../../../config/apiKey";

// function OnlineTutoring() {
//   const ID = getHitID();
//   const admin = JSON.parse(localStorage.getItem("edo-admin"));
//   const [data, setData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [showSecondModal, setShowSecondModal] = useState(false);
//   const [loading, setLoading] = useState(true); // Add loading state
//   useEffect(() => {
//     const fetchData = async () => {
// //setIsLoading(true);; // Start loading before data fetch
//       try {
//         const response = await axios.get(
//           `${apiKey}/api/edolutions/admin/read-notifications/${ID}`,
//           {
//             headers: {
//               Authorization: `Bearer ${admin?.token}`,
//             },
//           }
//         );
//         setData(response.data.data);
//         console.log(response.data.data)
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//       finally {
//         setLoading(false); // Stop loading after data fetch
//       }
//     };

//     fetchData();
//   }, [ID,admin?.token]);

//   const handleSearch = (e) => {
//     setSearchTerm(e.target.value);
//   };

//   const filteredData = data.filter(
//     (item) =>
//       item.student_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.class_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.subjects.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.day_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.start_time.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.duration.toLowerCase().includes(searchTerm.toLowerCase())
//   );


//    // Time format
//    function formatTime(time) {
//     let [hours, minutes] = time.split(":");
//     let period = "AM";

//     hours = parseInt(hours, 10);

//     if (hours >= 12) {
//       period = "PM";
//       if (hours > 12) {
//         hours -= 12;
//       }
//     } else if (hours === 0) {
//       hours = 12;
//     }

//     return `${hours}:${minutes} ${period}`;
//   }

//   return (
//     <>
//       <div className="flex items-center xl:p-5 max-sm:max-w-xs max-sm:mx-auto sm:p-0 justify-center">
//         <div className="w-full border rounded-3xl shadow-xl p-5">
//           <TeacherCard />
//           <div className="flex flex-wrap md:justify-start justify-center space-x-5 border-b-2 text-base font-medium ">
//             <NavLink
//               to="../mentor-dash"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
//                   : undefined
//               }
//             >
//               Dashboard
//             </NavLink>

//             <NavLink
//               to=".././mentor-message"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
//                   : undefined
//               }
//             >
//               View Profile
//             </NavLink>

//             <NavLink
//               to=".././online-sessions"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
//                   : undefined
//               }
//             >
//               Sessions
//             </NavLink>

//             {/* <NavLink
//               to=".././homeTutoring"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-blue-500 border-b-2 border-blue-500"
//                   : undefined
//               }
//             >
//               Home Tutoring
//             </NavLink> */}

//            <NavLink
//               to=".././mentor-chat"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
//                   : undefined
//               }
//             >
//               Messages
//             </NavLink> 

//             {/* <NavLink
//               to=".././teacherReport"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-blue-500 border-b-2 border-blue-500"
//                   : undefined
//               }
//             >
//               Report
//             </NavLink> */}
//           </div>

      
//               <div className="mt-2 max-sm:max-w-xs max-sm:w-[95%] overflow-auto p-2">
//                 <div className="flex flex-wrap items-center justify-between p-2">
//                   {/* <div className="flex justify-between">
//                     <p className="text-[22px] font-bold">Online Tution</p>
//                   </div> */}
//                   <div className="flex items-center">
//                     <div className="relative border shadow-md rounded-md flex items-center px-5 py-2">
//                       <FiSearch className="h-5 w-5 absolute text-[#5963F5]" />
//                       <input
//                         type="text"
//                         className="outline-none pl-8"
//                         placeholder="Search"
//                         value={searchTerm}
//                         onChange={handleSearch}
//                       />
//                     </div>
//                     {/* <div className="border-2 border-[#5963F5] rounded-md px-3 py-2 flex gap-2 ml-4">
//                       <FaPlus className="h-5 w-3 item-center fill-[#5963F5]" />
//                       <button
//                         className="text-[#5963F5] text-[14px] font-semibold"
//                         onClick={() => setShowModal(true)}
//                       >
//                         Create Class
//                       </button>
//                     </div> */}
//                   </div>
//                 </div>

//                 <div className="mt-5">
//                   <table className="w-full text-sm text-left text-gray-500 border-b table-auto">
//                     <thead className="text-sm text-[#B5B7C0] font-medium border-b">
//                       <tr className="border-b">
//                         <td className="py-5 px-1">Mentees Name</td>
//                         <td className="py-5 px-1">Profession</td>
//                         <td className="py-5 px-1">Specialization</td>
//                         <td className="py-5 px-1">Day</td>
//                         <td className="py-5 px-1">Timing</td>
//                         <td className="py-5 px-1">Duration</td>
//                         <td className="py-5 px-1">Payment</td>
//                       </tr>
//                     </thead>
//                     <tbody className="text-black text-sm font-medium">
//   {loading ? (
//     <tr>
//       <td colSpan="9" className="py-5 px-1 text-center">
//         <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
//           <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#EE5F2B]"></div>
//           <p className="mt-4 text-lg font-semibold text-[#EE5F2B]">
//             Cabil...
//           </p>
//         </div>
//       </td>
//     </tr>
//   ) : filteredData.length === 0 ? (
//     <tr>
//       <td colSpan="9" className="py-5 px-1 text-center">
//         <p className="text-gray-500">No Online Tution Available</p>
//       </td>
//     </tr>
//   ) : (
//     filteredData.map((item, index) => (
//       <tr key={index} className="border-b">
//         <td className="py-5 px-1">{item.student_name}</td>
//         <td className="py-5 px-1">{item.class_name}</td>
//         <td className="py-5 px-1">{item.subjects}</td>
//         <td className="py-5 px-1 capitalize">
//           {item.day_name ? item.day_name : "Not Define"}
//         </td>
//         <td className="py-5 px-1">
//                             {item.start_time && item.end_time
//                               ? `${formatTime(item.start_time)} to ${formatTime(
//                                   item.end_time
//                                 )}`
//                               : item.timeslot_id}
//                           </td>
//         <td className="py-5 px-1">
//           {item.days} {item.duration}
//         </td>
//         <td className="py-5 px-1">Rs.{item.payment}</td>
//       </tr>
//     ))
//   )}
// </tbody>

//                   </table>
//                 </div>

//                 {/* 1-modal */}
//                 {showModal && (
//                   <>
//                     <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
//                       <div className="relative mx-auto w-1/3">
//                         <div className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none overflow-y-auto shiftmodel">
//                           <div className="items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">
//                             <button
//                               className="ml-auto float-right text-2xl"
//                               onClick={() => setShowModal(false)}
//                             >
//                               <span className="text-[#000]"> × </span>
//                             </button>
//                           </div>
//                           <div className="text-center">
//                             <h1 className="text-[24px] font-semibold text-[#000]">
//                               Enter Class Details
//                             </h1>
//                             <p className="text-[12px] font-semibold text-[#2D3748]">
//                               Lorem Ipsum is simply dummy text of the printing.
//                             </p>
//                           </div>
//                           <div className="relative p-4 text-start h-60">
//                             <div className="text-center my-4">
//                               <input
//                                 type="date"
//                                 placeholder="Select Date"
//                                 className="input-date border-2 w-80 px-6 py-2 rounded-md text-gray-700 focus:outline-none focus:border-[#2BACE2] date-icon-color"
//                               />
//                             </div>
//                             <div className="text-center my-4">
//                               <select
//                                 placeholder="Select Subject"
//                                 name="subject"
//                                 className="border-2 w-80 px-6 py-2 rounded-md text-gray-700 focus:outline-none focus:border-[#2BACE2]"
//                               >
//                                 <option value="">Select</option>
//                                 <option value="math">Math</option>
//                                 <option value="english">English</option>
//                               </select>
//                             </div>
//                             <div className="text-center my-4">
//                               <select
//                                 name="student"
//                                 className="border-2 w-80 px-6 py-2 rounded-md text-gray-700 focus:outline-none focus:border-[#2BACE2]"
//                               >
//                                 <option value="">Select</option>
//                                 <option value="sohail">Muhammad Sohail</option>
//                                 <option value="muslim">Muhammad Muslim</option>
//                                 <option value="irfan">Irfan Ahmed</option>
//                               </select>
//                             </div>
//                           </div>
//                           <div className="text-center mb-7">
//                             <button
//                               className="font-semibold text-white text-[20px] border-2 rounded-lg bg-[#5963F5] px-6 cursor-pointer py-3"
//                               onClick={() => setShowSecondModal(true)}
//                             >
//                               Generate Link
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
//                   </>
//                 )}

//                 {/* 2-modal */}
//                 {showSecondModal && (
//                   <>
//                     <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
//                       <div className="relative mx-auto w-1/3">
//                         <div className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none overflow-y-auto shiftmodel">
//                           <div className="items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">
//                             <button
//                               className="ml-auto float-right text-2xl"
//                               onClick={() => setShowSecondModal(false)}
//                             >
//                               <span className="text-[#000]"> × </span>
//                             </button>
//                           </div>
//                           <div className="text-center">
//                             <h1 className="text-[24px] font-semibold text-[#000]">
//                               Class Zoom Link
//                             </h1>
//                             <p className="text-[12px] font-semibold text-[#2D3748]">
//                               Lorem Ipsum is simply dummy text of the printing.
//                             </p>
//                           </div>
//                           <div className="relative p-4 text-start h-60">
//                             <div className="text-center my-4">
//                               <h1>Link Here</h1>
//                             </div>
//                           </div>
//                           <div className="text-center mb-7">
//                             <button className="font-semibold text-white text-[20px] border-2 rounded-lg bg-[#5963F5] px-6 cursor-pointer py-3">
//                               Send the Students
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
//                   </>
//                 )}
//               </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default OnlineTutoring;

import React, { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import TeacherCard from "./TeacherCard";
import { FiSearch } from "react-icons/fi";
import { FaPlus } from "react-icons/fa";
import { getHitID } from "../../../config/HitIDStorage";
import axios from "axios";
import apiKey from "../../../config/apiKey";
import { useTranslation } from "react-i18next";

function OnlineTutoring() {
  const { t } = useTranslation();
  const ID = getHitID();
  const admin = JSON.parse(localStorage.getItem("edo-admin"));

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // UI state
  const [searchTerm, setSearchTerm] = useState("");
  const [dayFilter, setDayFilter] = useState("all");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${apiKey}/api/edolutions/admin/read-notifications/${ID}`,
          { headers: { Authorization: `Bearer ${admin?.token}` } }
        );
        setData(res.data?.data || []);
      } catch (e) {
        console.error("Error fetching data:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [ID, admin?.token]);

  // Time format (safe)
  function formatTime(time) {
    if (!time || typeof time !== "string") return "";
    let [hours, minutes] = time.split(":");
    let period = "AM";
    hours = parseInt(hours, 10);
    if (hours >= 12) {
      period = "PM";
      if (hours > 12) hours -= 12;
    } else if (hours === 0) {
      hours = 12;
    }
    return `${hours}:${minutes} ${period}`;
  }

  const daysList = useMemo(() => {
    const set = new Set();
    data.forEach((d) => d?.day_name && set.add(d.day_name));
    return ["all", ...Array.from(set)];
  }, [data]);

  const filteredData = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    return (data || []).filter((item) => {
      const matchesText =
        !term ||
        item?.student_name?.toLowerCase?.().includes(term) ||
        item?.class_name?.toLowerCase?.().includes(term) ||
        item?.subjects?.toLowerCase?.().includes(term) ||
        item?.day_name?.toLowerCase?.().includes(term) ||
        item?.start_time?.toLowerCase?.().includes(term) ||
        item?.duration?.toLowerCase?.().includes(term);

      const matchesDay = dayFilter === "all" || (item?.day_name || "") === dayFilter;
      return matchesText && matchesDay;
    });
  }, [data, searchTerm, dayFilter]);

  // Skeleton rows
  const skeleton = (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-5">
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          className="rounded-2xl p-4 bg-white/70 shadow animate-pulse border"
        >
          <div className="h-5 w-2/3 bg-gray-200 rounded mb-3" />
          <div className="h-4 w-1/2 bg-gray-200 rounded mb-2" />
          <div className="h-4 w-1/3 bg-gray-200 rounded mb-2" />
          <div className="flex gap-2 mt-3">
            <div className="h-6 w-20 bg-gray-200 rounded-full" />
            <div className="h-6 w-24 bg-gray-200 rounded-full" />
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <div className="flex items-center xl:p-5 max-sm:max-w-xs max-sm:mx-auto sm:p-0 justify-center">
        <div className="w-full border rounded-3xl shadow-xl p-5 bg-white">
          <TeacherCard />

          {/* Tabs */}
          <div className="flex flex-wrap md:justify-start justify-center gap-5 border-b text-base font-medium mt-2">
            <NavLink
              to="../mentor-dash"
              className={({ isActive }) =>
                isActive
                  ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B] pb-1"
                  : undefined
              }
            >
              {t("adminDash.findTeacher.dashboard")}
            </NavLink>
            <NavLink
              to=".././mentor-message"
              className={({ isActive }) =>
                isActive
                  ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B] pb-1"
                  : undefined
              }
            >
              {t("adminDash.homeTutoring.viewProfile")}
            </NavLink>
            <NavLink
              to=".././online-sessions"
              className={({ isActive }) =>
                isActive
                  ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B] pb-1"
                  : undefined
              }
            >
              {t("adminDash.studentDash.sessions")}
            </NavLink>
            <NavLink
              to=".././mentor-chat"
              className={({ isActive }) =>
                isActive
                  ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B] pb-1"
                  : undefined
              }
            >
              {t("adminDash.messages")}
            </NavLink>
          </div>

          {/* Sticky search/filters bar - NOW non-wrapping with horizontal scroll */}
          <div className="mt-4 sticky top-2 z-10">
            <div className="rounded-2xl bg-white/70 backdrop-blur border p-3 shadow-sm">
              <div className="flex flex-col gap-3">
                <p className="text-xl font-semibold">{t("adminDash.onlineTutoring.mentorSessions")}</p>

                {/* Tools Row */}
                <div className="flex items-center gap-3 flex-nowrap overflow-x-auto">
                  {/* Day filter pills container with scroll */}
                  <div className="flex items-center gap-2 flex-nowrap overflow-x-auto min-w-fit">
                    {daysList.map((d) => (
                      <button
                        key={d}
                        onClick={() => setDayFilter(d)}
                        className={`px-3 py-1.5 rounded-full text-sm border whitespace-nowrap transition
                          ${
                            dayFilter === d
                              ? "text-white border-transparent bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B]"
                              : "text-[#2A3A54] border-[#2A3A54]/40 bg-white hover:bg-[#2A3A54]/5"
                          }`}
                        title={d === "all" ? t("adminDash.onlineTutoring.allDays") : d}
                      >
                        {d === "all" ? t("adminDash.studentNoti.all") : d}
                      </button>
                    ))}
                  </div>

                  {/* Spacer that lets search+button stay on same line */}
                  <div className="flex-1" />

                  {/* Search - fixed width so it doesn't collapse */}
                  <div className="relative border rounded-xl px-3 py-2 shadow-sm bg-white min-w-[230px] md:min-w-[280px]">
                    <FiSearch className="h-5 w-5 absolute left-3 top-2.5 text-[#5963F5]" />
                    <input
                      type="text"
                      className="outline-none pl-8 text-sm w-full"
                      placeholder={t("adminDash.onlineTutoring.searchPlaceholder")}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>

                  {/* New session - gradient theme, no wrap */}
                  {/* <button
                    onClick={() => setShowCreateModal(true)}
                    className="inline-flex items-center gap-2 text-sm font-semibold text-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B] px-4 py-2 rounded-xl shadow whitespace-nowrap"
                  >
                    <FaPlus className="shrink-0" /> New Session
                  </button> */}
                </div>
              </div>
            </div>
          </div>

          {/* Mobile: card grid | Desktop: table */}
          <div className="mt-4 max-sm:max-w-xs max-sm:w-[95%] overflow-visible p-2">
            {/* Mobile / Small: Cards */}
            <div className="grid md:hidden grid-cols-1 gap-4">
              {loading
                ? skeleton
                : filteredData.length === 0
                ? (
                  <div className="rounded-2xl border p-6 text-center text-gray-500 bg-white/70">
                    {t("adminDash.onlineTutoring.noOnlineSessionsAvailable")}
                  </div>
                )
                : filteredData.map((item, idx) => (
                  <div key={idx} className="rounded-2xl border bg-white/80 p-4 shadow-sm">
                    <div className="flex items-center justify-between">
                      <p className="text-lg font-semibold">{item.student_name}</p>
                      <span className="text-xs px-2 py-1 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200">
                        {item.class_name}
                      </span>
                    </div>

                    <p className="text-sm text-gray-600 mt-1">{item.subjects}</p>

                    <div className="flex flex-wrap gap-2 mt-3">
                      <span className="text-xs px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 capitalize">
                        {item.day_name || t("adminDash.studentTution.notDefined")}
                      </span>
                      <span className="text-xs px-2.5 py-1 rounded-full bg-slate-100 text-slate-700 border border-slate-200">
                        {item.start_time && item.end_time
                          ? `${formatTime(item.start_time)} – ${formatTime(item.end_time)}`
                          : item.timeslot_id || "—"}
                      </span>
                      <span className="text-xs px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200">
                        {item.days} {item.duration}
                      </span>
                      <span className="ml-auto text-xs px-2.5 py-1 rounded-full bg-[#2DD0A5]/10 text-[#2DD0A5] border border-[#2DD0A5]/40">
                        Rs.{item.payment}
                      </span>
                    </div>
                  </div>
                ))}
            </div>

            {/* Desktop: Table */}
            <div className="hidden md:block">
              <div className="rounded-2xl border overflow-hidden bg-white/80">
                <table className="min-w-[260px] w-full text-left">
                  <thead className="text-sm text-[#6B7280] font-medium border-b bg-white">
                    <tr>
                      <th className="py-4 px-4">{t("adminDash.onlineTutoring.mentee")}</th>
                      <th className="py-4 px-4">{t("adminDash.studentTution.profession")}</th>
                      <th className="py-4 px-4">{t("adminDash.academicSubject.specializationLabel")}</th>
                      <th className="py-4 px-4">{t("adminDash.studentTution.day")}</th>
                      <th className="py-4 px-4">{t("adminDash.studentTution.timing")}</th>
                      <th className="py-4 px-4">{t("adminDash.demoClass.durationLabel")}</th>
                      <th className="py-4 px-4">{t("adminDash.studentTution.payment")}</th>
                    </tr>
                  </thead>
                  <tbody className="text-sm text-black">
                    {loading ? (
                      [...Array(6)].map((_, i) => (
                        <tr key={i} className="border-b animate-pulse">
                          <td className="py-4 px-4"><div className="h-4 bg-gray-200 rounded w-2/3" /></td>
                          <td className="py-4 px-4"><div className="h-4 bg-gray-200 rounded w-1/3" /></td>
                          <td className="py-4 px-4"><div className="h-4 bg-gray-200 rounded w-1/2" /></td>
                          <td className="py-4 px-4"><div className="h-6 bg-gray-200 rounded w-20" /></td>
                          <td className="py-4 px-4"><div className="h-6 bg-gray-200 rounded w-32" /></td>
                          <td className="py-4 px-4"><div className="h-4 bg-gray-200 rounded w-16" /></td>
                          <td className="py-4 px-4"><div className="h-6 bg-gray-200 rounded w-20" /></td>
                        </tr>
                      ))
                    ) : filteredData.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="py-8 text-center text-gray-500">
                          {t("adminDash.onlineTutoring.noOnlineSessionsAvailable")}
                        </td>
                      </tr>
                    ) : (
                      filteredData.map((item, index) => (
                        <tr key={index} className="border-b hover:bg-white">
                          <td className="py-4 px-4">{item.student_name}</td>
                          <td className="py-4 px-4">{item.class_name}</td>
                          <td className="py-4 px-4">{item.subjects}</td>
                          <td className="py-4 px-4 capitalize">
                            <span className="w-full text-xs px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
                              {item.day_name || t("adminDash.studentTution.notDefined")}
                            </span>
                          </td>
                          <td className="py-4 px-4">
                            <span className="text-xs px-2.5 py-1 rounded-full bg-slate-100 text-slate-700 border border-slate-200">
                              {item.start_time && item.end_time
                                ? `${formatTime(item.start_time)} – ${formatTime(item.end_time)}`
                                : item.timeslot_id || "—"}
                            </span>
                          </td>
                          <td className="py-4 px-4">
                            {item.days} {item.duration}
                          </td>
                          <td className="py-4 px-4">
                            <span className="text-xs px-2.5 py-1 rounded-full bg-[#2DD0A5]/10 text-[#2DD0A5] border border-[#2DD0A5]/40">
                              Rs.{item.payment}
                            </span>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Mobile New Session Button (gradient) */}
          <div className="md:hidden mt-4">
            {/* <button
              onClick={() => setShowCreateModal(true)}
              className="w-full inline-flex items-center justify-center gap-2 text-sm font-semibold text-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B] px-4 py-3 rounded-xl shadow whitespace-nowrap"
            >
              <FaPlus /> New Session
            </button> */}
          </div>
        </div>
      </div>

      {/* Create Session Modal */}
      {showCreateModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="relative w-full max-w-lg">
              <div className="bg-white rounded-3xl shadow-2xl p-5 sm:p-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-semibold">{t("adminDash.onlineTutoring.createSession")}</h3>
                  <button
                    className="text-2xl leading-none"
                    onClick={() => setShowCreateModal(false)}
                  >
                    ×
                  </button>
                </div>
                <p className="text-xs text-gray-500 mb-4">
                  {t("adminDash.onlineTutoring.fillDetails")}
                </p>

                <div className="space-y-3">
                  <div>
                    <label className="text-sm font-medium">{t("adminDash.onlineTutoring.date")}</label>
                    <input
                      type="date"
                      className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none"
                    />
                  </div>
                  <div>
                    <label className="text-sm font-medium">{t("adminDash.academicSubject.specializationLabel")}</label>
                    <select className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none">
                      <option value="">{t("adminDash.onlineTutoring.select")}</option>
                      <option value="math">{t("adminDash.homeTution.math")}</option>
                      <option value="english">{t("adminDash.homeTution.english")}</option>
                    </select>
                  </div>
                  <div>
                    <label className="text-sm font-medium">{t("adminDash.onlineTutoring.mentee")}</label>
                    <select className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none">
                      <option value="">{t("adminDash.onlineTutoring.select")}</option>
                      <option value="sohail">Muhammad Sohail</option>
                      <option value="muslim">Muhammad Muslim</option>
                      <option value="irfan">Irfan Ahmed</option>
                    </select>
                  </div>
                </div>

                <div className="flex justify-end gap-2 mt-5">
                  <button
                    className="px-4 py-2 rounded-xl border"
                    onClick={() => setShowCreateModal(false)}
                  >
                    {t("adminDash.common.cancel")}
                  </button>
                  <button
                    className="px-4 py-2 rounded-xl text-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B]"
                    onClick={() => {
                      setShowCreateModal(false);
                      setShowLinkModal(true);
                    }}
                  >
                    {t("adminDash.onlineTutoring.generateLink")}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="fixed inset-0 bg-black/30 z-40"
            onClick={() => setShowCreateModal(false)}
          />
        </>
      )}

      {/* Generated Link Modal */}
      {showLinkModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="relative w-full max-w-lg">
              <div className="bg-white rounded-3xl shadow-2xl p-5 sm:p-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-semibold">{t("adminDash.onlineTutoring.classZoomLink")}</h3>
                  <button
                    className="text-2xl leading-none"
                    onClick={() => setShowLinkModal(false)}
                  >
                    ×
                  </button>
                </div>
                <p className="text-xs text-gray-500 mb-4">
                  {t("adminDash.onlineTutoring.shareLink")}
                </p>
                <div className="rounded-xl bg-[#F9FBFF] p-4 text-sm border">
                  <p className="break-all">
                    https://zoom.example.com/j/123-456-789?pwd=abcdef
                  </p>
                </div>
                <div className="flex justify-end gap-2 mt-5">
                  <button
                    className="px-4 py-2 rounded-xl text-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:from-[#2A3A54] hover:to-[#EE5F2B]"
                    onClick={() => setShowLinkModal(false)}
                  >
                    {t("adminDash.onlineTutoring.sendToStudents")}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="fixed inset-0 bg-black/30 z-40"
            onClick={() => setShowLinkModal(false)}
          />
        </>
      )}
    </>
  );
}

export default OnlineTutoring;
